// Deep-link resolution (pure, node-testable).
//
// A ?cluster= link names a SIGNAL but no run — and the job view defaults to
// the latest run. When the signal lives in an older run (the incidents screen
// links exactly such signals), the view must switch to the newest run that
// actually SHOWS it, or say honestly why it can't.

/** The newest of this job's trend runs in which the cluster was seen.
 *  `trendRunIdsNewestFirst` decides recency — store order is not trusted. */
export function resolveRunForCluster(runsSeen, trendRunIdsNewestFirst) {
  if (!Array.isArray(runsSeen) || runsSeen.length === 0) return null;
  const seen = new Set(runsSeen.map(String));
  return (trendRunIdsNewestFirst || []).find((id) => seen.has(String(id))) || null;
}
